export enum CircleType {
  Small = 'SmallCircle',
  Medium = 'MediumCircle',
  Large = 'LargeCircle',
}
